import { render, staticRenderFns } from "./OrderBinTableAdmin.vue?vue&type=template&id=550e5a58&scoped=true"
import script from "./OrderBinTableAdmin.vue?vue&type=script&lang=js"
export * from "./OrderBinTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e5a58",
  null
  
)

export default component.exports